// extracted by mini-css-extract-plugin
export default {"Heading":"roomSettings__Heading__x7FJY"};